import React from 'react';

import Button from '../../../components/ui/Button';

const BulkActionsToolbar = ({ selectedCount, onAction }) => {
  if (selectedCount === 0) return null;

  const actions = [
    { id: 'renew', label: 'Renew Membership', icon: 'RefreshCw', variant: 'default' },
    { id: 'freeze', label: 'Freeze Accounts', icon: 'Pause', variant: 'outline' },
    { id: 'message', label: 'Send Message', icon: 'Mail', variant: 'outline' },
    { id: 'export', label: 'Export Data', icon: 'Download', variant: 'outline' },
    { id: 'deactivate', label: 'Deactivate', icon: 'UserX', variant: 'destructive' }
  ];

  return (
    <div className="bg-primary/10 border border-primary/20 rounded-xl p-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-semibold">
          {selectedCount}
        </div>
        <div>
          <p className="text-sm font-medium text-foreground">
            {selectedCount} {selectedCount === 1 ? 'member' : 'members'} selected
          </p>
          <p className="text-xs text-muted-foreground">Choose an action to apply</p>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2 w-full md:w-auto">
        {actions?.map((action) => (
          <Button
            key={action?.id}
            variant={action?.variant}
            size="sm"
            onClick={() => onAction(action?.id)}
            iconName={action?.icon}
            iconPosition="left"
            className="flex-shrink-0"
          >
            <span className="hidden lg:inline">{action?.label}</span>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default BulkActionsToolbar;